export const getCurrentColumns = state => state.session.currentColumns;